import { render, staticRenderFns } from "./ItsOrderInBound.vue?vue&type=template&id=9db20dcc&scoped=true&"
import script from "./ItsOrderInBound.vue?vue&type=script&lang=js&"
export * from "./ItsOrderInBound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db20dcc",
  null
  
)

export default component.exports